<div class="mb-4" *ngIf="fb && fb.error">
  <lib-error [title]="getText()" [error]="fb.error"></lib-error>
</div>

<div class="normal-container">
  <form [formGroup]="searchFormGroup">
    <exui-search-location *ngIf="countryLoaded" [permission]="permission" [countries]="countries"
      (countryChanged)="countryValidation($event)" (searchResultEmitter)="overrideRule($event)" (errorEmitter)="searchLocationComponentError()"
      (locationSelected)="locationSelected($event)" [form]="searchFormGroup" (formEmitter)="searchFormGroup = $event">
    </exui-search-location>

    <div class="col-12 manual-input-link mb-4"
      *ngIf="searchFormGroup?.controls?.country?.value && overrideAllowEditForm">
      <a href="javascript:void(0)" (click)="showAddress()">
        {{'Enter Address Manually' | translate}}
      </a>
    </div>

    <lib-address-details *ngIf="formGroup && allowEditForm" [permission]="permission" [formGroup]="formGroup"
      (formGroupEmitter)="formGroup = $event" [allowAddressNameField]="allowAddressNameField"
      [defaultCountry]="countryLookup" [parentFormSubmitted]="parentFormSubmitted"
      (isContactNumberVerified)="checkContactNumberIsVerified($event)" [contactNumberRequired]="contactNumberRequired">
    </lib-address-details>

    <div *ngIf="isBusy" class="col-12 text-center mb-4">
      <lib-loading [status]="'text-secondary'" [spinnerPosition]="true" [text]="" [size]="'md'">
      </lib-loading>
    </div>
  </form>
</div>

<app-address-suggestion-options (choiceEmitter)="confirmSuggestion($event)" [suggestedAddress]="suggestedAddress"
  [address]="address" *ngIf="viewMode === ViewModeEnum.Suggestion">
</app-address-suggestion-options>

<ng-template #verificationFailedModal let-modal class="modal-lg">
    <app-address-retry-continue-options (retryEmitter)="retry($event)" >
    </app-address-retry-continue-options>

</ng-template>
